import { createAction } from './utils'

const reducer = 'LISTS'

const openOrCloseListNest = createAction(reducer, 'OPEN_OR_CLOSE_NEST')

export { openOrCloseListNest }
